import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {IPaymentArticlesTypeRepository} from "@/repository/finance/payment_articles/PaymentArticlesTypeRepository.types";
import {IPaymentArticlesType, PaymentArticlesTypeResponseType} from "@/entity/finance/payment_articles/paymentArticlesType.types";
import PaymentArticlesType from "@/entity/finance/payment_articles/paymentArticlesType";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";

export class PaymentArticlesTypeRepository implements IPaymentArticlesTypeRepository {
    async fetchAll(data?: PaginationRequestType): Promise<PaymentArticlesType[]> {
        const resp = await Api.get('/finance/payment_articles/types/get', { params: data, paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const respData = resp.data as PaymentArticlesTypeResponseType[];
        return respData.map((item: PaymentArticlesTypeResponseType) => new PaymentArticlesType(item));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/finance/payment_articles/types/delete', data);
        return resp.data;
    }
}